var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper chiller-theme"},[_c('main',{staticClass:"page-content"},[_c('router-view')],1),_c('loader-item',{attrs:{"isLoader":this.$root.fullscreenLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }